export enum BlueBoxTextType {

  hidden = -1,
  draw = 0

}